import React from 'react'
import { Link } from 'react-router-dom';
import InputForm from './InputForm';


function ContactForm() {

    return (
        <>
            <div className='container-fluid mb-lg-5 mb-3 py-lg-5 py-3 contactus-main'>
                <div className='container-lg'>
                    <div className='row '>
                        <div className='col-md-6 mb-4'>
                            <div className='row contact-us'>
                                <h1>Feel Free to talk to us</h1>
                            </div>
                            <div className='row contact-us'>
                                <p>At Waywys, we are always ready for new collaborations and opportunities. Our response team is available 24*7 to answer all your digital marketing and related queries. Get in touch with us as we would be more than happy to help you!!</p>
                            </div>

                            <div className='d-flex gap-2 contact-us'>
                                <i className="fa-solid fa-location-dot"></i>
                                <Link to='https://maps.app.goo.gl/v7ANnqKVYZStYaxA7'> Sahibzada Ajit Singh Nagar, Punjab 160066</Link>
                            </div>

                            <div className='d-flex align-items-center gap-2 contact-us'>
                                <i className="fa-solid fa-envelope"></i>
                                <Link to='mailto:waywys.it@gmail.com'>waywys.it@gmail.com</Link>
                            </div>


                            <div className='d-flex align-items-center gap-2 contact-us'>
                                <i className="fa-brands fa-whatsapp"></i>
                                <Link to='https://wa.me/+919729170195?text=Welcome to waywys' target='_blank'>+91 9729170195 </Link> 
                            </div>


                        </div>
                        <div className='col-md-6 mb-4'>
                            <InputForm />
                        </div>

                    </div>

                </div>
            </div>

        </>
    )
}

export default ContactForm